
<div class="jhm-modal-background add-contact-modal">
    <div id="add-contact-inmate" class="jhm-modal">
      <div class="edit-body modal-body">
        <div class="top">
          <div class="icon-header">
            <i class="fa-regular fa-user-plus add-user-icon"></i>
          </div>
          <button class="jhm-icon-button transparent close-modal-button" (click)="cancelAddContact()"><i class="fa-regular fa-times"></i></button>
        </div>
        @if (!createNewContact) {
          <div class="description">
            <span>Add a contact.</span> Search for them by email or username or add a new one.
          </div>
          <div class="horizontal-line horizontal-line-give"></div>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="searchQuery" (ngModelChange)="this.searchQueryUpdate.next($event)" placeholder={{contactSearchPlaceholder}} #input>
          </mat-form-field>
          @if (potentialContacts) {
            <div class="results">
              @for (contact of potentialContacts; track contact; let isFirst = $first; let isLast = $last) {
                <div class="contact-container" [class.first]="isFirst" [class.last]="isLast">
                  <div class="contact-info">
                    <div class="name">
                      {{contact.fullName}}
                    </div>
                    <div class="username">
                      {{contact.username}}
                    </div>
                  </div>
                  <div class="add-contact">
                    @if (!contact.hasBeenAdded) {
                      <div class="image-container" (click)="addContact(contact.userId)">
                        <img src="./assets/images/add.svg">
                      </div>
                    }
                    @if (contact.hasBeenAdded) {
                      <div (click)="addContact(contact.userId)">
                        User Added
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (potentialContacts?.length < 1 && searchQuery && !searching) {
            <div>
              No results found for your search.
            </div>
          }
          @if (searching) {
            <div>
              Searching...
            </div>
          }
          @if (userType === 'INMATE') {
            <div class="horizontal-line horizontal-line-give"></div>
            <div class="mid-line-or">or</div>
            <button class="jhm-button" [ngClass]="{'primary': !searchQuery}" (click)="createNewContact = true">+ Create a New Contact</button>
          }
        }
        @if (createNewContact) {
          <div>
            <span class="bolded-beginning">Create a new contact</span> by putting in their email address below.
          </div>
          <div class="horizontal-line horizontal-line-give"></div>
          <input matInput [(ngModel)]="emailToBeAdded" placeholder="Email Address" #input>
          <div class="horizontal-line horizontal-line-give"></div>
        }
      </div>
      @if (createNewContact) {
        <footer class="filled modal-buttons">
          <button class="jhm-button" (click)="cancelAddContact()">Back</button>
          <button class="jhm-button primary" (click)="createContact()">Create Contact</button>
        </footer>
      }
    </div>
  </div>
